import { combineReducers } from 'redux'

import Auth from './ducks/Auth'
import Organisation from './ducks/Organisation'
import Reference from './ducks/Reference'
import User from './ducks/User'
import Upload from './ducks/Upload'

import Sidebar from './ducks/Sidebar'
import GotoTop from './ducks/GotoTop'

import AdminCreatedUserAdd from './ducks/AdminCreatedUser/Add'
import AdminCreatedUserList from './ducks/AdminCreatedUser/List'

import BankList from './ducks/Bank/List'
import BankAdd from './ducks/Bank/Add'
import BankEdit from './ducks/Bank/Edit'

import CountryTaxList from './ducks/CountryTax/List'
import CountryTaxAdd from './ducks/CountryTax/Add'
import CountryTaxEdit from './ducks/CountryTax/Edit'

import FormatList from './ducks/Format/List'
import FormatAdd from './ducks/Format/Add'
import FormatEdit from './ducks/Format/Edit'
import FormatRemove from './ducks/Format/Remove'

import ProductLanguageList from './ducks/ProductLanguage/List'
import ProductLanguageAdd from './ducks/ProductLanguage/Add'
import ProductLanguageEdit from './ducks/ProductLanguage/Edit'

import ProductTypeList from './ducks/ProductType/List'
import ProductTypeAdd from './ducks/ProductType/Add'
import ProductTypeEdit from './ducks/ProductType/Edit'

import FinanceProfileList from './ducks/FinanceProfile/List'
import ProfileList from './ducks/Profile/List'
import ProfileDetail from './ducks/Profile/Detail'
import ProfileBankInformationList from './ducks/ProfileBankInformation/List'

import ProductList from './ducks/Product/List'
import ProductDetail from './ducks/Product/Detail'
import ProductPortfolio from './ducks/Product/Portfolio'

import ProjectList from './ducks/Project/List'
import ProjectComment from './ducks/Project/Comment'
import ProjectDetail from './ducks/Project/Detail'
import ProjectPitch from './ducks/Project/Pitch'
import ProjectRemittance from './ducks/Project/Remittance'
import ProjectPaymentConfirmation from './ducks/Project/PaymentConfirmation'
import PurchaseOrderList from './ducks/Project/PurchaseOrder'
import ProjectManagement from './ducks/Project/Management'

import ZotapayInvoices from './ducks/ZotapayInvoices/List'

import RunProject from './ducks/ProjectList/List'

import ServiceList from './ducks/Service/List'
import ServiceAdd from './ducks/Service/Add'
import ServiceEdit from './ducks/Service/Edit'
import ServiceRemove from './ducks/Service/Remove'

import StandardList from './ducks/Standard/List'
import StandardAdd from './ducks/Standard/Add'
import StandardEdit from './ducks/Standard/Edit'

import TagList from './ducks/Tag/List'
import TagAdd from './ducks/Tag/Add'
import TagEdit from './ducks/Tag/Edit'
import TagRemove from './ducks/Tag/Remove'

import OccupationList from './ducks/Occupation/List'
import OccupationAdd from './ducks/Occupation/Add'
import OccupationEdit from './ducks/Occupation/Edit'
import OccupationRemove from './ducks/Occupation/Remove'

import TaskDetail from './ducks/TaskList/Detail'
import TaskList from './ducks/TaskList/List'

import TaxList from './ducks/Tax/List'
import TaxAdd from './ducks/Tax/Add'

import EmailList from './ducks/Email/List'
import EmailAdd from './ducks/Email/Add'
import EmailEdit from './ducks/Email/Edit'

import UserList from './ducks/User/List'

import Impersonate from './ducks/Impersonate'

import DialogAlert from './ducks/DialogAlert'

import GeneratePDF from './ducks/GeneratePDF'

export default combineReducers({
  Auth,
  Organisation,
  Reference,
  User,
  Sidebar,
  GotoTop,
  Upload,

  AdminCreatedUserAdd,
  AdminCreatedUserList,

  BankList,
  BankAdd,
  BankEdit,

  CountryTaxList,
  CountryTaxAdd,
  CountryTaxEdit,

  FormatList,
  FormatAdd,
  FormatEdit,
  FormatRemove,

  ProductLanguageList,
  ProductLanguageAdd,
  ProductLanguageEdit,

  ProductTypeList,
  ProductTypeAdd,
  ProductTypeEdit,

  ProductList,
  ProductDetail,
  ProductPortfolio,

  ProjectList,
  ProjectComment,
  ProjectDetail,
  ProjectPitch,
  ProjectRemittance,
  ProjectPaymentConfirmation,
  PurchaseOrderList,
  ProjectManagement,

  FinanceProfileList,

  ProfileList,
  ProfileDetail,

  ProfileBankInformationList,

  ZotapayInvoices,

  RunProject,

  ServiceList,
  ServiceAdd,
  ServiceEdit,
  ServiceRemove,

  StandardList,
  StandardAdd,
  StandardEdit,

  TagList,
  TagAdd,
  TagEdit,
  TagRemove,

  OccupationList,
  OccupationAdd,
  OccupationEdit,
  OccupationRemove,

  TaskDetail,
  TaskList,

  TaxList,
  TaxAdd,

  EmailList,
  EmailAdd,
  EmailEdit,

  UserList,

  Impersonate,

  DialogAlert,

  GeneratePDF,
})
